<template>
  <div class="page">
 <studentCard :snCode='$route.query.snCode'  :schoolCode='$route.query.schoolCode' teacher/>
<div>
  <!-- <div style="margin:0 10px;">
    <van-grid :column-num="2" direction="horizontal">
      <van-grid-item icon="medal-o" text="体测报告"    @click="onSeeReport()"/>
      <van-grid-item icon="notes-o" text="体锻报告" @click="onbodyReport()"/>
    </van-grid>
   
  </div> -->
<div class="box">
    <div class="box_title"> 体测成绩</div>
    <div v-for="(item,i) in scoreList" :key="i" class="box_ul">
        <div class="box_li">
             <div >{{item.projectName||''}}<span class="box_li_unit"></span></div>
             <div class="box_li_score">
                <!-- <div v-if="+item.auditStatus==1" class="isAuditStatus">
                  <img src="@/assets/image/待审核.png" alt="" width="50">
                </div> -->
                <div style="width:80%; text-align: right;" >{{item.score||'--'}}{{item.unit}}
                </div>
                <div style="width:20%">
                  <el-button type="text" size="mini" v-if="item.projectCode!=='HeightWeight'"  style="margin:0 10px" @click="onreport(item)">登记</el-button>
               </div>
             
             </div>
                
             
        </div>
    </div>
</div>

    <!-- <div v-for="(item,i) in scoreList" :key="i" class="box_ul">
        <div class="box_li">
             <div>{{item.projectName||''}}<span class="box_li_unit">{{item.unit}}</span></div>
             <div class="box_li_score">
                <div v-if="+item.auditStatus==1" class="isAuditStatus">
                  <img src="@/assets/image/待审核.png" alt="" width="50">
                </div>
                <div style="width:40%">{{item.score||'--'}}
                </div>
                <div style="width:40%"><van-button type="primary" size="mini"  style="margin:0 10px" @click="onreport(item)">申 报</van-button></div>
             </div>
        </div>
    </div> -->
</div>




<van-popup   style="height:100%;width: 100%" v-model:show="showDialog" width="90%" :title="`${reportData.projectName}登记`" :show-confirm-button='false' >
    <van-form @submit="onSubmit" style="margin:20px 0">

        <VfieldRule v-model="score" v-if="reportData.projectName == '身高'" :maxNumber='300'  :precision='1'>
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '体重'" :maxNumber='300'  :precision='1'>
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '仰卧起坐'" :maxNumber='999' >
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
         
          <VfieldRule v-model="score" v-if="reportData.projectName == '跳绳'" :maxNumber='999' >
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '引体向上'" :maxNumber='999' >
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '肺活量'" :maxNumber='9999' >
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '立定跳远'" :maxNumber='360'  :precision='1'>
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '50米'" :maxNumber='100'  :precision='2'>
            <template #label>
              <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>

        <VfieldRule v-model="score"  v-if="reportData.projectName=='坐位体前屈'" :rules='false' :labelWidth='110' :maxNumber='35'  :precision='1' >
           <template #label>
            <span>成绩{{reportData.unit}}
                <span style="color:red;">*</span>
              </span>
           </template>
            <template #input>
                 <van-checkbox v-model="scoreSign" shape="square" style="margin-left:10px;">
                <span v-show="!scoreSign">+</span>
                <span v-show="scoreSign">-</span>
              </van-checkbox>
           </template>
          
         </VfieldRule>

    <van-sticky :offset-top="'77vh'">
        <div class="buutom">
    <CustomButton  class="button-on" text="返回" @click="showDialog=false" type='2'/>
    <CustomButton   class="button-on"text="确认" native-type="submit" type='1'/>
        </div>
      </van-sticky>

  <!-- <div class="buutom">
    <CustomButton  text="返回" @click="showDialog=false" type='2'/>
    <CustomButton  text="确认" native-type="submit" type='1'/>

  </div> -->
      </van-form>

</van-popup>

  </div>
</template>

<script>
import studentCard from "@/components/studentCard.vue";
import CustomButton from "@/components/CustomButton.vue";
import PublicUpLoader from "@/components/PublicUpLoader.vue";
import VfieldRule from "@/components/VfieldRule.vue";

import { Dialog } from 'vant'
import moment from 'moment'
import { getScoreBySnCode,submitScore} from "@/api/teacher/teacherReporting.js";
import VCellField from "@/components/VCellField";
export default {
  name: 'addTest',
  components: { studentCard,CustomButton,VCellField ,PublicUpLoader,VfieldRule},
  data () {
    return {
      testTips: false,
      scoreSign: false,
      userInfo: {},
      status: {
        1: '已测试',
        2: '已过期',
        3: '未测试'
      },
   
      backgroundColor: {
        1: '#f7b331',
        2: '#ff7079',
        3: '#c7c7c7'
      },
      time: ['上午', '下午', '晚上'],
      auditStatus: ['正常', '有审核中的状态'],
      clickInfo: {},
      scoreList:[],
      showDialog:false,
      reportData:{},
      file:[],
      score:undefined,

      upLoaderItem:{
      type: 'Uploader',
      label: '视频',
      accept: 'video/*',
      disabled: false,
      icon: require('@/assets/appeal/video-icon.png'),
      max: 1,
      upType: 'video', //类型
      name: 'file',
      upName: '添加视频', //自定义名称
      rules: [{ required: true, message: '请添加视频' }],
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    onSeeReport(){
      let data = JSON.stringify({
         snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
            termCode:this.$route.query.termCode,
            // projectCode:item.projectCode,
            teacher:true
      })
        this.$router.push({path:'/fitnessReport',query:{data:data}})
    },
    onbodyReport(){
      let data = JSON.stringify({
         snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
            termCode:this.$route.query.termCode,
            // projectCode:item.projectCode,
            teacher:true
      })
      this.$router.push({path:'/bodyForging',query:{data:data}})
  },
    onGoDetil(item){
      console.log(item);
      this.$router.push({path:'scoreInfo',query:{
            snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
            termCode:this.$route.query.termCode,
            projectCode:item.projectCode,
      }})
    },
    changeUpLoader(val){
        console.log(val);
    },
    onreport(item){
        this.reportData =item
        this.score = undefined
        this.file = []

        this.showDialog =true
    },
    afterRead(file){
        console.log(1,file);
    },
    onOversize(file){
        console.log(2,file);

    },
    beforeRead(file){
        console.log(2,file);
      return true

    },
    onSubmit(item){

 if (!this.score||this.score=='') {
  this.$notify({ type: "danger", message: '请填入成绩数据' });
    return
}
if (this.score) {
var scoreJSON = JSON.parse(JSON.stringify(this.score))
}

if (this.reportData.projectName=='坐位体前屈') {


  if (this.scoreSign) {
    scoreJSON = 0 - +scoreJSON
  }
}

if (this.reportData.projectName!=='坐位体前屈'&&+scoreJSON<0) {
  this.$notify({ type: "danger", message: '成绩数据超出合理范围' });
  return
}

 this.$dialog
        .alert({
          message: '是否确认登记?',
          showCancelButton: true
        })
        .then(() => {
            let data = {
              
              score:scoreJSON,
              snCode:this.$route.query.snCode,
              schoolCode:this.$route.query.schoolCode,
              projectCode:this.reportData.projectCode
            }
            submitScore(data).then(Res=>{
            this.$notify({ type: "success", message: '登记成功！' });
            this.init()
            this.showDialog =false
            })
        })
    },
    moment,
    forDetail (item) {
      this.clickInfo = item
      this.testTips = true
    },

    init(){
      this.getScoreBySnCode()

    },
   getScoreBySnCode(){
        getScoreBySnCode({
            snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
            code:this.$route.query.termCode,
            
          }).then(res=>{
           
            res.data.data?.forEach(el=>{
              switch(el.projectName) {
                case '肺活量': return el.unit= '（毫升）'
                case '坐位体前屈': return el.unit= '（厘米）'
                case '立定跳远': return el.unit= '（厘米）'
                case '仰卧起坐': return el.unit= '（个）'
                case '50*8往返跑': return el.unit= '（秒）'
                case '跳绳': return el.unit= '（个）'
                case '体重': return el.unit= '（千克）'
                case '身高': return el.unit= '（厘米）'
                case '50米': return el.unit= '（秒）'
                default: return el.unit= ''
                }
            })
            this.scoreList = res.data.data||[]
         
          }).catch(err=>{
            console.log(err);
              this.$router.back(-1)
          })
    },
    // getLog () {
    //   getScoreBySnCode({
    //     activityOrder: {
    //       snCode: this.userInfo.snCode
    //     }
    //   }).then(({ data }) => {
    //     this.scoreList = data
    //   })
    // },
 
  }
}
</script>

<style lang="less" scoped>
.box{
    background-color: #fff;
    margin: 8px;
    border-radius: 8px;
    padding: 8px 10px;
    .box_title{
      font-weight: 600;
      font-size: 4vw;
      margin: 5px 0;
    }
    .box_ul{
    // margin: 8px;
.box_li{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    font-size: 3.7vw;
    font-weight: 450;
    border-bottom: 1px solid #f5f5f5;
    color: #666;

    .isAuditStatus{
    position: absolute;

    }
    .box_li_unit{
        font-size: 13px;
        color: #bbb;
    }
    .box_li_score{
     
     width: 62%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1a1a1a;
    font-weight: 600;

    }
}

}
}

.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .button-on{
    width: 48%;
}
}
</style>
